module.exports = {
  viteusa: {
    title: 'ViteUSA - leading WMS platform and services',
    iconHref: 'static/vite32px.png',
    metaContent: "The leading warehouse management system (WMS) and warehousing services that help organizations and buyers do business. It supports doctor, nurse, oversea warehouse, FBA, FBM"
  },
  far800: {
    primaryColor: '#305a8a',
    title: 'MAXIMUS',
    iconHref: 'static/maximus.png',
    metaContent: "The leading warehouse management system (WMS) and warehousing services that help organizations and buyers do business. It supports doctor, nurse, oversea warehouse, FBA, FBM"
  },
  fsd915: {
    primaryColor: '#137c7c',
    title: 'FSD-Express',
    iconHref: 'static/fsd915.png',
    metaContent: "The leading warehouse management system (WMS) and warehousing services that help organizations and buyers do business. It supports doctor, nurse, oversea warehouse, FBA, FBM"
  },
  eagle: {
    primaryColor: '#809f5f',
    title: 'ShipRateShop',
    iconHref: 'static/shiprateshop.png',
    metaContent: "The leading warehouse management system (WMS) and warehousing services that help organizations and buyers do business. It supports doctor, nurse, oversea warehouse, FBA, FBM"
  }
}


//////////////////
// WEBPACK FOOTER
// ./config/htmlConfig.js
// module id = 35Yh
// module chunks = 15